var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"fancy",class:{
        green: _vm.isGreen,
        ['light-orange']: _vm.isLightOrange,
        ['outlined-orange']: _vm.isOutlinedOrange,
        ['grey']: _vm.isGrey,
    },scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopedSlotName){return {key:scopedSlotName,fn:function(slotData){return [_vm._t(scopedSlotName,null,null,slotData)]}}}),_vm._l((_vm.$slots),function(_,slotName){return {key:slotName,fn:function(){return [_vm._t(slotName)]},proxy:true}})],null,true)},'v-btn',{ ..._vm.$attrs, ..._vm.commonAttrs },false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }